import { Box, Grid, Typography } from '@mui/material'
import { useForm } from 'react-hook-form'
import { RecoveryPasswordFormValues } from './types'
import { yupResolver } from '@hookform/resolvers/yup'
import { validationRecoveryPassword } from './validation'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useLazyQuery } from '@apollo/client'
import { OPERATION_RECOVERY_PASSWORD } from 'pages/Auth/operations-gql/mutations'
import RecoverySuccessPanel from './RecoverySuccessPanel'
import { useState } from 'react'
import LoginEmail from '../../components/LoginEmail'
import ErrorMessage from '../../components/ErrorMessage'

import LoginButton from '../../components/LoginButton'
import LoginPaper from '../../components/LoginPaper'

const RecoveryPasswordPanel = () => {
  const { t } = useTranslation()
  const navigation = useNavigate()

  const [currEmail, setEmail] = useState('')

  const [recoveryPassword, { data, loading, error }] = useLazyQuery(OPERATION_RECOVERY_PASSWORD, {
    variables: { email: '' }
  })

  const {
    handleSubmit,
    register,
    formState: { errors, isValid }
  } = useForm<RecoveryPasswordFormValues>({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    resolver: yupResolver(validationRecoveryPassword(t))
  })

  const handleRecovery = ({ email }) => {
    setEmail(email)
    recoveryPassword({ variables: { email } })
  }

  const handleCancel = () => {
    navigation('/auth/login')
  }

  if (data?.recovery?.status === true) {
    return <RecoverySuccessPanel email={currEmail} />
  }

  return (
    <LoginPaper>
      <Grid container spacing={2} maxWidth={'400px'}>
        <Grid item xs={12}>
          <Typography
            sx={{
              textAlign: 'center',
              fontSize: '24px',
              lineHeight: '36px',
              fontWeight: 600,
              color: 'content.secondary'
            }}
          >
            {t('login.ask_password')}
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <ErrorMessage
            sx={{
              visibility: error ? 'visible' : 'hidden',
              textAlign: 'center'
            }}
          >
            {t('login.error.invalid_email')}
          </ErrorMessage>
        </Grid>
        <Grid item xs={12}>
          <LoginEmail
            error={Boolean(errors.email)}
            errorMessage={errors.email?.message}
            InputProps={{
              ...register('email', { required: true })
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <Box display="flex" gap={2} sx={{ width: '100%' }}>
            <LoginButton
              outlined
              fullWidth
              sx={{ flex: 1 }}
              onClick={handleCancel}
            >
              {t('login.cancel')}
            </LoginButton>
            <LoginButton
              loading={loading}
              variant="contained"
              disabled={!isValid}
              fullWidth
              sx={{
                flex: 2
              }}
              onClick={handleSubmit(handleRecovery)}
            >
              {t('login.send')}
            </LoginButton>
          </Box>
        </Grid>
      </Grid>
    </LoginPaper>
  )
}

export default RecoveryPasswordPanel
